export function abortError(): DOMException { return new DOMException("Call cancelled", "AbortError"); }

/** Starts every setup task together and stops waiting immediately when the call is cancelled. */
export function parallelSetup(tasks: Array<() => Promise<unknown>>, signal: AbortSignal): Promise<void> {
  if (signal.aborted) return Promise.reject(abortError());
  return new Promise((resolve, reject) => {
    const abort = () => { signal.removeEventListener("abort", abort); reject(abortError()); };
    signal.addEventListener("abort", abort, { once: true });
    Promise.all(tasks.map(task => Promise.resolve().then(() => {
      if (signal.aborted) throw abortError();
      return task();
    })))
      .then(() => signal.aborted ? reject(abortError()) : resolve(), reject)
      .finally(() => signal.removeEventListener("abort", abort));
  });
}

export function setupDelay(milliseconds: number, signal?: AbortSignal): Promise<void> {
  if (signal?.aborted) return Promise.reject(abortError());
  return new Promise((resolve, reject) => {
    const abort = () => { window.clearTimeout(timer); reject(abortError()); };
    const timer = window.setTimeout(() => { signal?.removeEventListener("abort", abort); resolve(); }, milliseconds);
    signal?.addEventListener("abort", abort, { once: true });
  });
}
